module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patient"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.patient.name))]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(_vm._s(_vm.$t("admin.patientspage")))])]), _vm._v(" "), (_vm.patient.patientData) ? _c('md-card-content', [_c('section', {
    staticClass: "row"
  }, [_c('div', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.patient.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b', [_vm._v("Életkor:")]), _vm._v(" " + _vm._s(_vm.patient.patientData.age)), _c('br'), _vm._v(" "), _c('b', [_vm._v("E-mail:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.patient.email
    }
  }, [_vm._v(_vm._s(_vm.patient.email))]), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("admin.mothersname")))]), _vm._v(" " + _vm._s(_vm.patient.patientData.mothersName)), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("admin.socialsecuritynumber")))]), _vm._v(" " + _vm._s(_vm.patient.patientData.socialSecurity)), _c('br')])]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("admin.medicines")))]), _vm._v(" "), _c('section', {
    staticClass: "row"
  }, _vm._l((_vm.patient.patientData.medication), function(medication) {
    return _c('div', {
      staticClass: "medication col-md-4"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v("\n\t\t\t\t\t\tNév: "), _c('b', [_vm._v(_vm._s(medication.name))]), _c('br'), _vm._v("\n\t\t\t\t\t\tKategória: " + _vm._s(medication.category)), _c('br'), _vm._v("\n\t\t\t\t\t\tForma: " + _vm._s(medication.form)), _c('br'), _vm._v("\n\t\t\t\t\t\tFelírt mennyiség: " + _vm._s(medication.frequencyUnit) + " x " + _vm._s(medication.frequencyVal) + " adag"), _c('br'), _vm._v("\n\t\t\t\t\t\tHatóanyag: " + _vm._s(medication.doseVal ? medication.doseVal : 'Nincs megadva')), _c('br')])])
  }))]) : _vm._e(), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    attrs: {
      "href": _vm.pdfUrl(),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.printsummary")))]), _vm._v(" "), _c('md-button', {
    on: {
      "click": function($event) {
        _vm.notifyPatient()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.findinspector")))])], 1)], 1), _vm._v(" "), _c('md-whiteframe', {
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('md-tabs', [_c('md-tab', {
    attrs: {
      "id": "monthly",
      "md-label": _vm.$t('admin.monthlyReport')
    }
  }, [_c('div', {
    staticClass: "row interval"
  }, [_c('span', {
    staticClass: "col-xs-4"
  }, [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.reportDate.subtract(1, 'months');
        _vm.loadReport();
      }
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("Előző hónap")], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-4"
  }, [_c('md-button', [_vm._v("Megjelenített hónap: " + _vm._s(_vm.reportDate.format("YYYY MMMM")))])], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-4"
  }, [(_vm.reportDate.isBefore(_vm.now)) ? _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.reportDate.add(1, 'months');
        _vm.loadReport();
      }
    }
  }, [_vm._v("Következő hónap"), _c('md-icon', [_vm._v("keyboard_arrow_right")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("admin.rescueMedSymptom")))])]), _vm._v(" "), _c('md-card-content', [_c('bar-chart', {
    attrs: {
      "values": _vm.dailyMedications
    }
  })], 1)], 1), _vm._v(" "), _c('md-table-card', [_c('md-table', {
    attrs: {
      "md-sort": "title",
      "md-sort-type": "desc"
    },
    on: {
      "sort": _vm.onSort
    }
  }, [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', {
    attrs: {
      "md-sort-by": "title"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.factor")))]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-sort-by": "value"
    }
  }, [_vm._v(_vm._s(_vm.$t("admin.value")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.tendency")))])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.data.factors), function(factor, index) {
    return _c('md-table-row', {
      key: index,
      attrs: {
        "md-item": factor
      }
    }, [_c('md-table-cell', {
      key: 'title',
      attrs: {
        "md-numeric": false
      }
    }, [_vm._v(_vm._s(factor.title))]), _vm._v(" "), _c('md-table-cell', {
      key: 'value',
      attrs: {
        "md-numeric": false
      }
    }, [(factor.unit === 'frequency') ? _c('span', [_vm._v("Főként: " + _vm._s(_vm.$t(factor.value)))]) : _c('span', [_vm._v(_vm._s(_vm.$t(factor.value)) + " " + _vm._s(_vm.$t(factor.unit)))])]), _vm._v(" "), _c('md-table-cell', [_vm._v("~")])], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Szöveges megjegyzések")])]), _vm._v(" "), _c('md-card-content', _vm._l((_vm.data.comments), function(comment) {
    return _c('div', [_c('div', {
      staticClass: "content"
    }, [_c('h3', [_vm._v(_vm._s(_vm.toShortDate(comment.updatedAt)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(comment.value))])])])
  }))], 1)], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "daily",
      "md-label": _vm.$t('admin.dailyReport')
    }
  }, [_c('vue-event-calendar', {
    attrs: {
      "events": _vm.measurementEvents
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((props.showEvents), function(measurement, index) {
          return _c('div', {
            staticClass: "event-item"
          }, [_c('b', [_vm._v("Type:")]), _vm._v(" " + _vm._s(_vm.$t(measurement.type))), _c('br'), _vm._v(" "), _c('b', [_vm._v("Value:")]), _vm._v(" " + _vm._s(_vm.$t(measurement.value))), _c('br'), _vm._v(" "), _c('b', [_vm._v("Time:")]), _vm._v(" " + _vm._s(_vm.timeFromDate(measurement.updatedAt)) + "\n\t\t\t\t\t\t")])
        })
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1073e7d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Patient.vue
// module id = 410
// module chunks = 2